import React from "react";
import { Button, Form, Input } from "antd";
import authService from "../../services/authService";
import { useSelector } from "react-redux";
import { RootState } from "../../store";
import PageHeader from "../../components/PageHeader";

const ProfilePage: React.FC = () => {
  const { user } = useSelector((s: RootState) => s.auth);
  const [pwdForm] = Form.useForm();

  const changePassword = async () => {
    try {
      const values = await pwdForm.validateFields();
      await authService.changePassword({
        currentPassword: values.currentPassword,
        newPassword: values.newPassword,
      });
      pwdForm.resetFields();
    } catch {
      // API errors toasted by interceptor; form validation stays inline
    }
  };

  return (
    <div>
      <PageHeader title="My Profile" />
      <div className="page-panel" style={{ marginBottom: 10 }}>
        <p style={{ marginBottom: 8 }}>
          <strong>Name:</strong> {user?.name}
        </p>
        <p style={{ marginBottom: 8 }}>
          <strong>Email:</strong> {user?.email}
        </p>
        <p style={{ marginBottom: 0 }}>
          <strong>Role:</strong> {user?.role}
        </p>
      </div>

      <div className="page-panel" style={{ maxWidth: 480 }}>
        <div className="dense-toolbar" style={{ marginBottom: 10 }}>
          <strong>Change Password</strong>
        </div>
        <Form form={pwdForm} layout="vertical">
          <Form.Item
            name="currentPassword"
            label="Current Password"
            rules={[{ required: true }]}
          >
            <Input.Password />
          </Form.Item>
          <Form.Item
            name="newPassword"
            label="New Password"
            rules={[{ required: true, min: 6 }]}
          >
            <Input.Password />
          </Form.Item>
          <Button type="primary" onClick={changePassword}>
            Update Password
          </Button>
        </Form>
      </div>
    </div>
  );
};

export default ProfilePage;
